import { render, staticRenderFns } from "./ProjectMsg.vue?vue&type=template&id=4e14a385&scoped=true"
import script from "./ProjectMsg.vue?vue&type=script&lang=js"
export * from "./ProjectMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e14a385",
  null
  
)

export default component.exports